module.exports = __webpack_public_path__ + "img/7.6a9c125c.png";